import {createApp} from 'vue';
import App from './App.vue'
import store from './store'
import {getTranslation, setTranslations} from "i18n";
import {call} from "io";

function adjustOtherInterferingElements() {
  const consentManagerButton = document.querySelector('#consent-settings-btn');
  if(consentManagerButton) {
    consentManagerButton.classList.add('d-none', 'd-lg-block');
  }

  const goToTopButton = document.querySelector('.scroll-to-top');
  if(goToTopButton) {
    goToTopButton.classList.add('d-none', 'd-lg-block');
  }
}

/**
 *
 * @param {App<Element>} app
 */
let currentlyMountedApp = null;
function checkIfAppIsMounted() {
  const container = document.getElementById(rootContainerId);
  console.log(container.__vue__);
}


const rootContainerId = 'wnm-product-configurator';
const createAppInstance = async () => {
  const rootContainer = document.getElementById(rootContainerId);

  adjustOtherInterferingElements();

  const articleId = JSON.parse(rootContainer.dataset.articleId);

  setTranslations(JSON.parse(rootContainer.dataset.translations));
  // const configGroups = JSON.parse(rootContainer.dataset.configGroups);
  const [{article: articleData}, {configGroups}] = await Promise.all([
    call('wnm.productConfigurator.loadArticle', {articleId}),
    call('wnm.productConfigurator.loadConfigGroups', {articleId})
  ]);

  const jtlToken = JSON.parse(rootContainer.dataset.jtlToken);
  const options = JSON.parse(rootContainer.dataset.options);
  const constants = JSON.parse(rootContainer.dataset.constants);

  await Promise.all([
    store.commit('SET_CONFIG_TYPES', constants.configTypes),
    store.commit('SET_OPTIONS', options),
    store.commit('SET_JTL_TOKEN', jtlToken),
    store.commit('SET_ARTICLE', articleData),
    store.dispatch('injectProductConfigDetails', configGroups),
  ]);
  const app = createApp(App).use(store);

  app.config.globalProperties.$filters = {
    trans(name, defaultTrans = '') {
      return getTranslation(name) ?? defaultTrans;
    },

    configTypes: constants.configTypes,

    formatCurrency(number) {
      const numberFormatter = new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'});
      return numberFormatter.format(number);
    }
  };
  return app;
};

if(document.getElementById(rootContainerId) !== null) {
  createAppInstance().then((app) => {
    app.mount(`#${rootContainerId}`);
  });
}

let needsRemount = false;
// jtl shop 5 replaces the parent article detail page with the child detail page
// due to the removal of all dom elements the element the vue app was bound to is also missing
// -> create a new app instance and mount to the "new" dom element
$(document).on('evo:loaded.io.request', (e, {req}) => {
  const {name} = req;
  $(document).one('evo:load.evo.content', () => {
    if(name === 'checkVarkombiDependencies') {
      needsRemount = true;
    }
  });

  $(document).one('evo:loaded.evo.content', () => {
    if(name === 'checkVarkombiDependencies') {
      if(needsRemount) {
        needsRemount = false;
        createAppInstance().then((app) => {
          console.log('remounting app');
          app.mount(`#${rootContainerId}`);
        });
      }
    }
  });
})
